import { render, staticRenderFns } from "./ScienceIntegrity.vue?vue&type=template&id=3152c040&scoped=true&"
import script from "./ScienceIntegrity.vue?vue&type=script&lang=js&"
export * from "./ScienceIntegrity.vue?vue&type=script&lang=js&"
import style0 from "./ScienceIntegrity.vue?vue&type=style&index=0&id=3152c040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3152c040",
  null
  
)

export default component.exports